var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('h3',[_vm._v(_vm._s(_vm.$t('home.title')))]),_c('p',[_vm._v(_vm._s(_vm.$t('home.description')))]),_c('service-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }